/* eslint-disable react-hooks/rules-of-hooks */
import { ButtonAction, actionsBack } from 'pages/NotifyEvent/styles'
import NotificationService from 'services/Notification'
import { useNavigate } from 'react-router-dom'
import { getDamage, getDamageColor } from 'utils/damage'
import NotificationActions from 'actions/Notification'
import { useDispatch } from 'react-redux'

function LeftSideV1({ currentNotificationSelected, notificationsList, setNotificationsList, isShowAnalyze }) {
    const navigate = useNavigate()
    const notificationDispatch = useDispatch()

    const notificationAnalyzer = () => {
        NotificationActions.setProgressBarNavClicked(notificationDispatch, false)
        currentNotificationSelected.u_notification_read.display_value = "true"
        currentNotificationSelected.u_notification_read.value = "true"
        NotificationService.readerNotification(currentNotificationSelected.sys_id.value, currentNotificationSelected)
        .then((response: any) => {
                let newListNotifications = [...notificationsList]
                newListNotifications.forEach((notification) => {
                    if (notification.sys_id.value === currentNotificationSelected.sys_id.value) {
                        notification.u_notification_read = true
                    }
                })

                setNotificationsList(newListNotifications)
                navigate(`/notificacoes/${currentNotificationSelected.sys_id.value}`)
            })
            .catch((error) => {
                console.log(error)
            })
    }


    return (!currentNotificationSelected) ? (
        <div className="flex justify-center flex-col w-full items-center">
            <svg
                width="75"
                height="76"
                viewBox="0 0 75 76"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M68.5963 61.699H2.30271C1.30148 61.699 0.416835 61.0666 0.108237 60.1417C-0.193502 59.2169 0.149384 58.2036 0.965452 57.6392C1.04774 57.578 11.0463 50.0909 11.0463 25.1203C11.0463 18.4356 13.5631 12.1453 18.1372 7.40551C22.6976 2.69971 28.9998 0 35.4461 0C36.8245 0 38.2029 0.122405 39.5401 0.360415C40.7882 0.578024 41.618 1.74767 41.3917 2.95812C41.1654 4.17538 39.9584 4.97101 38.7172 4.7534C37.6474 4.56299 36.5502 4.46779 35.4461 4.46779C30.1862 4.46779 25.2349 6.59628 21.4975 10.4656C17.7806 14.3146 15.6478 19.6528 15.6478 25.1203C15.6478 42.6582 10.9777 52.3826 7.45286 57.2244H63.4393C60.6139 53.3414 57.0479 46.3167 55.7518 34.6611C55.6146 33.4302 56.5267 32.3286 57.7954 32.1994C59.0572 32.0565 60.1956 32.9542 60.3327 34.1782C62.3146 51.9542 69.8787 57.5916 69.9541 57.646C70.7496 58.2172 71.0925 59.2373 70.777 60.1485C70.4684 61.0666 69.5907 61.6922 68.6031 61.6922L68.5963 61.699Z"
                    fill="#474747"
                    fillOpacity="0.4"
                />
                <path
                    d="M61.2305 25.9304C57.6644 25.9304 54.311 24.5839 51.7874 22.1358C49.2637 19.6877 47.8785 16.4304 47.8785 12.969C47.8785 9.50769 49.2637 6.25035 51.7874 3.80225C54.311 1.35415 57.6644 0.00769043 61.2305 0.00769043C64.7965 0.00769043 68.1499 1.35415 70.6735 3.80225C73.1972 6.25035 74.5824 9.50769 74.5824 12.969C74.5824 16.4304 73.1972 19.6877 70.6735 22.1358C68.1499 24.5839 64.7965 25.9304 61.2305 25.9304ZM61.2305 4.46868C58.892 4.46868 56.6975 5.35271 55.0448 6.95758C53.3921 8.56245 52.48 10.6977 52.48 12.9622C52.48 15.2267 53.3921 17.362 55.0448 18.9737C56.6975 20.5786 58.892 21.4626 61.2305 21.4626C63.5689 21.4626 65.7634 20.5786 67.4161 18.9737C69.0688 17.3688 69.9809 15.2335 69.9809 12.969C69.9809 10.7045 69.0688 8.56925 67.4161 6.96438C65.7634 5.35951 63.5689 4.47548 61.2305 4.47548V4.46868Z"
                    fill="#474747"
                    fillOpacity="0.4"
                />
                <path
                    d="M35.4453 75.9999C33.7514 75.9999 32.085 75.5647 30.6174 74.7419C29.1499 73.9259 27.9292 72.7358 27.0788 71.3145C26.4411 70.2469 26.8182 68.88 27.9155 68.2612C29.0196 67.6424 30.4254 68.0096 31.0632 69.0772C31.5089 69.8185 32.1467 70.4441 32.9148 70.8725C34.4509 71.7362 36.4328 71.7362 37.9689 70.8725C38.737 70.4441 39.3747 69.8185 39.8205 69.0772C40.4582 68.0096 41.8641 67.6424 42.9682 68.2612C44.0654 68.88 44.4426 70.2469 43.8048 71.3145C42.9545 72.7358 41.7338 73.9259 40.2662 74.7419C38.7987 75.5647 37.1323 75.9999 35.4384 75.9999H35.4453Z"
                    fill="#474747"
                    fillOpacity="0.4"
                />
            </svg>
            <span className='max-w-[250px] mt-4 text-center font-normal text-darkGray80'>Selecione uma notificação para visualizar o resumo</span>
        </div>
    ) : (currentNotificationSelected &&
        (<div className="flex flex-col">
            <span className="hard-colored-text px-6 mt-4">
                {currentNotificationSelected.incident_title.display_value}
            </span>
            <span className="hard-dark-text px-6">{currentNotificationSelected.number.display_value}</span>
            <div className="flex justify-between border-b border-borderLine px-6 pb-3">
                <div className="flex items-center gap-2">
                    <span
                        className={`chip-incidente incidente-${getDamageColor(getDamage(currentNotificationSelected.damage_level.value)?.value)}`}
                    >
                        {currentNotificationSelected.damage_level.display_value}
                    </span>
                    {currentNotificationSelected.u_reopening_date?.value && (
                        <span className='text-darkGray text-[10px] bg-[#E5E5E5] px-2 rounded-[14px] flex h-full items-center gap-1 max-h-[18px]'>
                            Reaberta
                        </span>
                    )}
                </div>
                <span className="header-notificacao-preview uppercase">
                    {currentNotificationSelected.sys_created_on.display_value}

                </span>
            </div>
            <div className="flex flex-col p-6">
                <div className="flex flex-col mb-2">
                    <span className="header-notificacao-preview">
                        Incidente
                    </span>
                    <span className="text-notificacao-preview">
                        {currentNotificationSelected?.incident_type?.display_value}
                    </span>


                </div>
                <div className="flex flex-col mb-2">
                    <span className="header-notificacao-preview">Unidade</span>
                    <span className="text-notificacao-preview">
                        {currentNotificationSelected.location_incident.display_value}
                    </span>
                </div>
                <div className="flex flex-col mb-2">
                    <span className="header-notificacao-preview">Setor</span>
                    <span className="text-notificacao-preview">
                        {currentNotificationSelected.incident_sector.display_value}
                    </span>
                </div>
                <div className="flex flex-col mb-2">
                    <span className="header-notificacao-preview">
                        Setor do notificante
                    </span>
                    <span className="text-notificacao-preview">
                        {currentNotificationSelected.reporter_sector.display_value}
                    </span>
                </div>
                <div className="flex-row mb-2 grid grid-cols-2">
                    <div className="flex flex-col">
                        <span className="header-notificacao-preview">
                            Data da ocorrência
                        </span>
                        <span className="text-notificacao-preview">
                            {currentNotificationSelected.date_incident.display_value}
                        </span>
                    </div>
                    <div className="flex flex-col">
                        <span className="header-notificacao-preview">
                            Tipo da notificação
                        </span>
                        <span className="text-notificacao-preview">
                            {currentNotificationSelected.notification_type.display_value}
                        </span>
                    </div>
                </div>
                <div className="flex-row mb-2 grid grid-cols-2">
                    <div className="flex flex-col">
                        <span className="header-notificacao-preview">
                            Envolve paciente
                        </span>
                        <span className="text-notificacao-preview">
                            {currentNotificationSelected.involves_patient.value === 'false' ? 'NÃO' : 'SIM'}
                        </span>
                    </div>
                    <div className="flex flex-col">
                        <span className="header-notificacao-preview">
                            Turno
                        </span>
                        <span className="text-notificacao-preview">
                            {currentNotificationSelected.shift_incident.display_value}
                        </span>
                    </div>
                </div>
                <div className="flex flex-col mb-2">
                    <span className="header-notificacao-preview">
                        Título do incidente
                    </span>
                    <span className="text-notificacao-preview">
                        {currentNotificationSelected.incident_title.display_value}
                    </span>
                </div>
                <div className="flex flex-col mb-2">
                    <span className="header-notificacao-preview">
                        Descrição do incidente
                    </span>
                    <span className="text-notificacao-preview text-justify">
                        {currentNotificationSelected.incident_description.display_value}

                    </span>
                </div>
                <div className="flex flex-col mb-2">
                    <span className="header-notificacao-preview">
                        Ação corretiva imediata
                    </span>
                    <span className="text-notificacao-preview text-justify">
                        {currentNotificationSelected.immediate_corrective_action.display_value}
                    </span>
                </div>
                <div className="flex flex-col mb-2">
                    <span className="header-notificacao-preview">
                        Fator contribuinte
                    </span>
                    <span className="text-notificacao-preview text-justify">
                        {currentNotificationSelected.contributing_mitigating_factors.display_value}
                    </span>
                </div>
                <div className="flex flex-col mb-2">
                    <span className="header-notificacao-preview">
                        Fator atenuante
                    </span>
                    <span className="text-notificacao-preview text-justify">
                        {currentNotificationSelected.mitigating_factors.display_value}
                    </span>
                </div>
            </div>

            {(isShowAnalyze) &&
                (<div className="flex justify-center">
                    <ButtonAction className={actionsBack} onClick={(notificationAnalyzer)}>
                        Analisar Notificação
                    </ButtonAction>
                </div>)
            }

        </div>)
    )
}

export default LeftSideV1
